import React from "react";
import Css from "./Footer.module.css";
import { FaFacebookF, FaGithub, FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <div>
      <div id="footer" className={Css.parent}>
        <div className={Css.container}>
          <div className={Css.icons}>
            <Link target="_blank" to="https://www.facebook.com/profile.php?id=100012706116123">
              <FaFacebookF />
            </Link>
            <Link target="_blank" to="https://www.linkedin.com/in/mohamed-adel-226611286/">
              <FaLinkedinIn />
            </Link>
            <Link target="_blank" to="https://github.com/Mohamed-Adel0">
              <FaGithub />
            </Link>
          </div>
          <div className={Css.text}>
            <h4>
              All rights reserved | This template is made with by <Link target="_blank" to="https://www.linkedin.com/in/mohamed-adel-226611286/">Mohamed-adel</Link>
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
